export const FETCH_APPLICATION_HOURS_STATS_PER_MONTH_REQUEST = 'FETCH_APPLICATION_HOURS_STATS_PER_MONTH_REQUEST';
export const FETCH_APPLICATION_HOURS_STATS_PER_MONTH_SUCCESS = 'FETCH_APPLICATION_HOURS_STATS_PER_MONTH_SUCCESS';
export const FETCH_APPLICATION_HOURS_STATS_PER_MONTH_FAILURE = 'FETCH_APPLICATION_HOURS_STATS_PER_MONTH_FAILURE';
export const FETCH_APPLICATION_HOURS_STATS_PER_MONTH_RESET = 'FETCH_APPLICATION_HOURS_STATS_PER_MONTH_RESET';
